import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

/**
 * SummaryCard
 *
 * Props:
 *  onClick      {fn}           — opens detail modal
 *  onDelete     {fn|undefined} — if provided, delete icon shown on hover
 *  width        {number}       — card width in px (default 200)
 *  highlighted  {bool}         — pricing "featured" style (default false)
 *  children     {node}         — content specific to this section type
 */
const SummaryCard = ({ onClick, onDelete, width = 200, highlighted = false, children }) => (
  <Box
    sx={{
      position: "relative",
      flex: `0 0 ${width}px`,
      background: highlighted ? "rgba(59,130,246,0.1)" : "rgba(255,255,255,0.04)",
      border: highlighted ? "2px solid #3b82f6" : "1px solid rgba(255,255,255,0.08)",
      borderRadius: "12px",
      p: 2,
      cursor: "pointer",
      transition: "border-color 0.18s, background 0.18s",
      "&:hover": {
        background: highlighted ? "rgba(59,130,246,0.15)" : "rgba(255,255,255,0.07)",
        borderColor: highlighted ? "#3b82f6" : "rgba(59,130,246,0.5)",
        "& .summary-controls": { opacity: 1 },
      },
    }}
    onClick={onClick}
  >
    {/* ── Hover controls (top-right) ── */}
    <Box
      className="summary-controls"
      sx={{
        position: "absolute",
        top: 8,
        right: 8,
        display: "flex",
        gap: 0.5,
        opacity: 0,
        transition: "opacity 0.18s",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Tooltip title="Edit">
        <IconButton
          size="small"
          onClick={onClick}
          sx={{
            width: 24,
            height: 24,
            borderRadius: "6px",
            background: "rgba(59,130,246,0.15)",
            color: "#3b82f6",
            "&:hover": { background: "rgba(59,130,246,0.28)" },
          }}
        >
          <EditIcon sx={{ fontSize: 12 }} />
        </IconButton>
      </Tooltip>

      {onDelete && (
        <Tooltip title="Delete">
          <IconButton
            size="small"
            onClick={onDelete}
            sx={{
              width: 24,
              height: 24,
              borderRadius: "6px",
              background: "rgba(239,68,68,0.12)",
              color: "#ef4444",
              "&:hover": { background: "rgba(239,68,68,0.25)" },
            }}
          >
            <DeleteOutlineIcon sx={{ fontSize: 12 }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>

    {children}
  </Box>
);

export default SummaryCard;